import type { CountryWithNumericId } from 'app/shared/api/getCountries';

function parsePositiveInt(v: unknown): number | undefined {
  if (v === undefined || v === null) return undefined;
  if (typeof v === 'number' && Number.isFinite(v) && v > 0) return v;
  if (typeof v === 'string') {
    const n = Number(v.trim());
    if (Number.isFinite(n) && n > 0) return n;
  }
  return undefined;
}

export function getCountryApiIdFromRow(c: CountryWithNumericId): number {
  const r = c as CountryWithNumericId & Record<string, unknown>;
  const keys = [
    'numericId',
    'countryId',
    'CountryId',
    'countryID',
    'numericCountryId',
    'id',
  ];
  for (const k of keys) {
    const n = parsePositiveInt(r[k]);
    if (n != null && n > 0) return n;
  }
  return 0;
}